import { useMemo, useState, useEffect } from 'react';
import CalendarDays from './CalendarDays';
import Icon from 'components/Icon';
import { useTranslation } from 'services/hooks';
import moment from 'moment';

import './style.css';

const Calendar = ({ onDayChange, markedDates }) => {
	const [currentDay, setCurrentDay] = useState(new Date());
	const getTranslation = useTranslation();

	const TRANSLATION_KEY = 'calendar';

	const newMarkedDates = useMemo(() => {
		if (!markedDates) return [];
		return markedDates.map(_date => moment(_date, 'DD-MM-YYYY hh:mm').format('MM-DD-YYYY  hh:mm'));
	}, [markedDates]);

	const weekdays = useMemo(() => {
		return [
			getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_sunday`),
			getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_monday`),
			getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_tuesday`),
			getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_wednesday`),
			getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_thursday`),
			getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_friday`),
			getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_saturday`),
		];
	}, [getTranslation]);

	const months = useMemo(() => {
		return [
			getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_january`),
			getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_february`),
			getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_march`),
			getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_april`),
			getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_may`),
			getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_june`),
			getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_july`),
			getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_august`),
			getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_september`),
			getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_october`),
			getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_november`),
			getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_december`),
		];
	}, [getTranslation]);

	useEffect(() => {
		onDayChange && typeof onDayChange === 'function' && onDayChange(currentDay);
	}, [currentDay]);

	const changeCurrentDay = ({ year, month, day }) => {
		setCurrentDay(new Date(year, month, day));
	};

	const nextMonth = () => {
		const newDate = currentDay.setMonth(currentDay.getMonth() + 1);
		setCurrentDay(new Date(newDate));
	};

	const previousMonth = () => {
		const newDate = currentDay.setMonth(currentDay.getMonth() - 1);
		setCurrentDay(new Date(newDate));
	};

	return (
		<div className="Calendar">
			<div className="Calendar__header">
				<div className="Calendar__header__title">
					<b>{months[currentDay.getMonth()]}</b> {currentDay.getFullYear()}
				</div>
				<div className="separator"></div>
				<div className="tools">
					<button className="monthBtn" onClick={() => previousMonth()}>
						<Icon icon="dropdownArrow" color="#92929d" />
					</button>

					<button className="monthBtn rotate" onClick={() => nextMonth()}>
						<Icon icon="dropdownArrow" color="#92929d" />
					</button>
				</div>
			</div>
			<div className="Calendar__body">
				{/* days header */}
				<div className="table__header">
					{weekdays.map((day, idx) => {
						return (
							<p key={idx} className="week_day">
								{day}
							</p>
						);
					})}
				</div>
				<CalendarDays markedDates={newMarkedDates} currentDay={currentDay} changeCurrentDay={changeCurrentDay} />
			</div>
		</div>
	);
};

export default Calendar;
